import { render, staticRenderFns } from "./ChangePasswd.vue?vue&type=template&id=125c4f2e&scoped=true&"
import script from "./ChangePasswd.vue?vue&type=script&lang=js&"
export * from "./ChangePasswd.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswd.vue?vue&type=style&index=0&id=125c4f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c4f2e",
  null
  
)

export default component.exports